import * as type from '../mutation-types';

const state = {
    shiftList: [],
};

const getters = {
    shiftList: state => {
        return state.shiftList;
    },
};

const mutations = {
    [type.SET_SHIFT_LIST](state, shiftList) {
        state.shiftList = shiftList;
    },
};

const actions = {
    getShiftList({ commit, rootState }, dates) {
        let api = Laroute.route('franchise.vue.shifts');

        axios
            .get(api, {
                params: {
                    outlet_id: rootState.report.activeOutlet,
                    since: moment(dates.since)
                        .startOf('day')
                        .format(),
                    until: moment(dates.until)
                        .endOf('day')
                        .format(),
                },
            })
            .then(response => {
                let data = response.data.data;
                commit(type.SET_SHIFT_LIST, data);
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/shifts.js